text{text-anchor:middle;dominant-baseline:central;paint-order:stroke;stroke:#000;fill:#fff;pointer-events:none}
/*# sourceMappingURL=svg-text.component.css.map */
